import { useVisitorIsPresent } from 'conversations-thread-data/presence/public/hooks';
import { useThreadDetails } from 'conversations-thread-view/thread-details-feature/public/hooks/useThreadDetails';
import { getData } from 'conversations-async-data/async-data/operators/getters';
import { getVid } from 'conversations-thread-data/thread-details/public/operators';
import { StatusDot } from 'foundations-components/transitional/components/StatusDot';
import { jsx as _jsx } from "react/jsx-runtime";
const StatusIndicator = ({
  threadId
}) => {
  const {
    asyncThreadDetails
  } = useThreadDetails({
    threadId
  });
  const threadDetailsData = getData(asyncThreadDetails);
  const vid = threadDetailsData ? getVid(threadDetailsData) : null;

  /*  @ts-expect-error Jun-7-2024, 15:40UTC TODO: fix broken types introduced from typing of ThreadDetails record: https://git.hubteam.com/HubSpot/conversations-thread-view/pull/3656  */
  const {
    visitorIsPresent
  } = useVisitorIsPresent({
    threadId,
    vid
  });
  return visitorIsPresent ? /*#__PURE__*/_jsx(StatusDot, {
    use: "success",
    inlineSize: "12px",
    blockSize: "12px",
    position: "absolute",
    insetInlineStart: "-10px",
    insetBlockStart: "7px"
  }) : null;
};
StatusIndicator.displayName = 'StatusIndicator';
export default StatusIndicator;